module.exports = __webpack_public_path__ + "static/media/bg6.ba113900.svg";